import * as ContactSupportActions from "actions/contact-support-actions";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ContactAndCopyright from "./contact-and-copyright";
import FooterLinks from "./footer-links";
import ReadyToGrow from "./ready-to-grow";

class Footer extends Component {
  openContactSupportModal = (e) => {
    e.preventDefault();
    this.props.actions.openModal();
  };

  render() {
    return (
      <div>
        <ReadyToGrow />
        <FooterLinks openContactSupportModal={this.openContactSupportModal} />
        <ContactAndCopyright openContactSupportModal={this.openContactSupportModal} />
      </div>
    );
  }
}

export default connect(null, (dispatch) => ({
  actions: bindActionCreators(ContactSupportActions, dispatch),
}))(Footer);
